export const spacing_size = 2;

export default {};
